import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useAskNoticeboard } from "./useAskNoticeboard";
import { askNoticeboardShortcutLabel } from "./shortcut";

/**
 * The top-bar icon. Hidden wherever Ask Noticeboard isn't available.
 * `onAppBar` is the phone's coloured app bar, where it takes the bar's text colour.
 */
const AskNoticeboardButton: React.FC<{ onAppBar?: boolean }> = ({ onAppBar = false }) => {
  const { isAvailable, isReady, open } = useAskNoticeboard();
  if (!isAvailable || !isReady) return null;

  return (
    <Tooltip title={`Ask Noticeboard (${askNoticeboardShortcutLabel()})`}>
      <IconButton
        onClick={open}
        aria-label="Ask Noticeboard"
        data-testid="top-nav-ask-noticeboard-button"
        sx={{
          color: onAppBar ? "inherit" : "primary.main",
          width: 36,
          height: 36,
          animation: "askNoticeboardIn 420ms cubic-bezier(0.2, 0.8, 0.2, 1)",
          "@keyframes askNoticeboardIn": {
            from: { opacity: 0, transform: "scale(0.4)" },
            to: { opacity: 1, transform: "scale(1)" },
          },
          "&:hover": {
            bgcolor: (theme) =>
              onAppBar ? alpha(theme.palette.common.white, 0.15) : alpha(theme.palette.primary.main, 0.1),
          },
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: 22 }} />
      </IconButton>
    </Tooltip>
  );
};

export default AskNoticeboardButton;
